import styled from 'styled-components'

import {
  IconButton,
  TypeStyle,
  fromLg,
  fromMd,
  timingSlower,
  untilLg,
} from '@syconium/little-miss-figgy'

import {
  CrossedOutPrice,
  DiscountPrice,
  Price,
} from '../../../../../brunswick/components/PriceDisplay/styles'
import {
  FitSection,
  SizeSection,
} from '../../../../../brunswick/components/VariantAttributeSelectors/styles'
import { fadeIn } from '../../../../../brunswick/styles/shared'

export const Body = styled.div`
  padding: 0 ${o => o.theme.spacing(4)};
  ${fromMd} {
    padding: 0 ${o => o.theme.spacing(6)};
  }
`

export const LoadingSpinnerWrapper = styled.div`
  align-items: center;
  animation: ${fadeIn} ${timingSlower} ease 0s 1 both;
  display: flex;
  height: 50vh;
  justify-content: center;

  ${fromLg} {
    height: 75vh;
  }
`

export const TilesList = styled.ul`
  margin-top: 12px;

  > * {
    border: 1px solid ${o => o.theme.color.deprecated.stoneLight};
    border-radius: 3px;
  }

  > * + * {
    margin-top: 16px;
  }

  ${fromLg} {
    margin-top: 21px;

    > * {
      border-left: none;
      border-radius: 0;
      border-right: none;

      &:not(:last-of-type) {
        border-bottom: none;
      }
    }

    > * + * {
      margin-top: 0;
    }
  }
`

export const Tile = styled.div`
  display: flex;
  overflow: hidden;
  ${untilLg} {
    align-items: center;
  }
  ${fromLg} {
    padding: 17px 0;
  }
`

export const TileText = styled.div`
  flex: 1;
  padding: 12px;

  ${fromLg} {
    padding-left: 28px;
  }
`

export const PriceAndColor = styled.div`
  align-items: flex-end;
  display: flex;
  margin-top: 4px;

  ${CrossedOutPrice},
  ${DiscountPrice},
  ${Price} {
    font-size: 11px;
    line-height: 1.5;

    ${fromLg} {
      font-size: 12px;
    }
  }
`

export const ColorName = styled(TypeStyle.BodyNano)`
  color: ${o => o.theme.color.deprecated.obsidianLighter};
  font-size: 11px;
  font-weight: bold;
  margin-left: 8px;

  ${fromLg} {
    display: none;
  }
`

export const QuickBuyButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

export const OpenQuickBuyModalButton = styled(IconButton)`
  ${fromLg} {
    display: none;
  }
`

export const DesktopContents = styled.div`
  display: none;

  ${fromLg} {
    display: flex;
    flex: 3;
    padding-top: 12px;
  }
`

export const VariantAttributeSelectorsWrapper = styled.div`
  flex: 2;

  ${FitSection} {
    margin-top: 18px;
  }

  ${SizeSection} {
    margin-top: 10px;
  }
`

export const DesktopButtonCtaWrapper = styled.div`
  flex: 1;
  padding-left: 16px;
`
